import { createFilledIcon } from "../createIcon";

export const HamburgerFilledIcon = createFilledIcon(
  <>
    <path d="M4 7H20V8.67969H4V7ZM4 12.8203V11.1797H20V12.8203H4ZM4 17V15.3203H20V17H4Z" />
  </>,
  "HamburgerFilledIcon"
);
